import React from "react";
import { Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { CareerType } from "src/shared/config";
import { RoutePaths } from "src/app/model";
import { employmentLabels } from "src/shared/model";

type VacancyItemProps = {
  career: CareerType;
};

export const VacancyItem: React.FC<VacancyItemProps> = (props) => {
  const { career } = props;

  const navigate = useNavigate();

  const handleApply = () => {
    const path = `${RoutePaths.CAREER}/${career.id}`;

    navigate(path);
  };

  return (
    <Stack
      width={1}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Stack direction="column">
        <Typography variant="h6" fontWeight="bold" color="primary.dark">
          {career.title}
        </Typography>

        <Typography variant="caption">
          {employmentLabels[career.employmentType]}, {career.location}
        </Typography>
      </Stack>

      <Button
        variant="contained"
        size="small"
        color="primary"
        onClick={handleApply}
      >
        Apply now
      </Button>
    </Stack>
  );
};
